import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import { Map } from 'immutable'

import FormModal from 'components/FormModal'
import Search from './search'
import FormContainer from './form-container'

class PaymentSchemes extends Component {

  constructor(props) {
    super(props)

    this.state = {
      openForm: false,
      item: null,
    }
  }

  _openForm = (paymentscheme) => {
    const item = Map.isMap(paymentscheme) ? paymentscheme : null
    this.setState({
      openForm: true,
      item,
    })
  }

  _closeForm = () => {
    this.setState({
      openForm: false,
    })
  }

  _renderForm() {
    const { openForm, item } = this.state

    if (!openForm) {
      return null
    }

    return (
      <FormModal handleClose={this._closeForm}>
        <FormContainer
          item={item}
          close={this._closeForm}
        />
      </FormModal>
    )
  }

  render() {
    const { __list, children } = this.props

    return (
      <div className="row">
        <div className="col-sm-3">
          <Search
            list={__list}
            onPSForm={this._openForm}
          />
        </div>
        <div className="col-sm-9">
          {React.cloneElement(children, { onPSForm: this._openForm })}
        </div>
        {this._renderForm()}
      </div>
    )
  }
}

PaymentSchemes.propTypes = {
  __list: PropTypes.object,
  children: PropTypes.node,
}

function mapStateToProps(state) {
  return {
    __list: state.paymentscheme.get('list'),
  }
}

export default connect(mapStateToProps)(PaymentSchemes)



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/index.js